import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import React from "react";
import Navbar from "../../../Components/Navbar";
import Footer from "../../../Components/Footer";
import AllWithdrawRequests from "../../../Components/AdminComponents/AllWithdrawRequests";

const AdminWithdrawRequests = () => {


    return (
        <>
        <VStack spacing={"auto"}>
            <Navbar logoLevel="2" />
            <Box mb={5} mt={2} w={"90%"}>
                <Heading as="h2" size="lg" p="3vh">
                    Withdrawal Requests
                </Heading>
                <Text className="sub_headings">
                    Here you can view all the withdrawal requests submitted by creators.
                </Text>
                <AllWithdrawRequests />
            </Box>
        </VStack>
        <Footer />
        </>
    );
};

export default AdminWithdrawRequests;
